import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { TokenService } from "./token.service";
import { delay, Observable, of } from "rxjs";
import { InventoryModel } from "../../models/inventory.model";
import { InventoryCountModel } from "../../models/inventory-count.model";
import { ListResponse } from "../../models/list-response.model";
import { InventoryCountItemModel } from "../../models/inventory-count-item.model";
import { ProductModel } from "../../models/product.model";

@Injectable({
    providedIn: 'root'
})
export class InventoryService {
    apiUrl = environment.API_URL + 'internal/';

    constructor(
        private httpClient: HttpClient,
        private tokenService: TokenService
    ) { }

    getCustomerHeader() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.tokenService.getComponentCodeToken(),
            'Accept-Language': 'pt-BR'
        });
    }

    public getInventoryHeaderList(branchCode: number, status: number, inventoryStartDate: Date | null, inventoryEndDate: Date | null, inventoryCode: number | null = null): Observable<ListResponse<InventoryModel>> {
        let params = new HttpParams()
            .set('branchCode', branchCode)
            .set('status', status);

        if (inventoryStartDate != null && inventoryEndDate != null) {
            params = params.set('inventoryStartDate', inventoryStartDate.toISOString().split('T')[0])
                .set('inventoryEndDate', inventoryEndDate.toISOString().split('T')[0]);
        }

        if (inventoryCode != null)
            params = params.set('inventoryCode', inventoryCode);

        return this.httpClient.get<any>(this.apiUrl + 'product-count/v2/inventory', {
            params: params,
            headers: this.getCustomerHeader()
        });
    }

    public getInventoryCountList(branchCode: number, status: number, inventoryCode: number, inventoryCount: number | null = null, inventoryCountDescription: string | null): Observable<ListResponse<InventoryCountModel>> {
        let params = new HttpParams()
            .set('branchCode', branchCode)
            .set('inventoryCountStatus', status);

        if (inventoryCode != null)
            params = params.set('inventoryCode', inventoryCode);

        if (inventoryCount != null)
            params = params.set('inventoryCountCode', inventoryCount);

        if (inventoryCountDescription != null && inventoryCountDescription !== '')
            params = params.set('inventoryCountDescription', inventoryCountDescription);

        return this.httpClient.get<any>(this.apiUrl + 'product-count/v2/inventory-count', {
            params: params,
            headers: this.getCustomerHeader()
        });
    }

    public getInventoryCountItemsList(branchCode: number, inventoryCode: number, inventoryCountCode: number | null): Observable<ListResponse<InventoryCountItemModel>> {
        let params = new HttpParams()
            .set('branchCode', branchCode)
            .set('inventoryCode', inventoryCode);

        if (inventoryCountCode != null)
            params = params.set('inventoryCountCode', inventoryCountCode);

        return this.httpClient.get<any>(this.apiUrl + 'product-count/v2/inventory-count-items', {
            params: params,
            headers: this.getCustomerHeader()
        });
    }

    public createInventoryCount(branchCode: number, inventoryHeaderCode: number, description: string): Observable<InventoryCountModel> {
        let data = {
            "branchCode": branchCode,
            "inventoryCode": inventoryHeaderCode,
            "description": description
        }

        return this.httpClient.post<any>(this.apiUrl + 'product-count/v2/inventory-headers-count', data, { headers: this.getCustomerHeader() });
    }

    public getProduct(BarCode: string, BranchCode: number): Observable<ListResponse<ProductModel>> {
        return this.httpClient.get<any>(this.apiUrl + 'product/v2/products/' + BarCode + '/' + BranchCode, { headers: this.getCustomerHeader() });
    }

    public postCountInventoryItem(branchCode: number, inventoryCode: number, inventoryCountCode: number, productCode: number, quantity: number, barCode: string, rfid: string | null = null): Observable<any> {
        let data = {
            "branchCode": branchCode,
            "inventoryCode": inventoryCode,
            "inventoryCountCode": inventoryCountCode,
            "items": [
                {
                    "productCode": productCode,
                    "quantity": quantity,
                    "barCode": barCode,
                    "rfid": rfid
                }
            ]
        };

        return this.httpClient.post<any>(this.apiUrl + 'product-count/v2/inventory-items-count', data, { headers: this.getCustomerHeader() });
    }

    public postFinalizeInventoryCount(branchCode: number, inventoryCode: number, inventoryCountCode: number): Observable<any> {
        let data = {
            "branchCode": branchCode,
            "inventoryCode": inventoryCode,
            "inventoryCountCode": inventoryCountCode,
        };

        return this.httpClient.post<any>(this.apiUrl + 'product-count/v2/finalize-inventory-count', data, { headers: this.getCustomerHeader() });
    }
}
